import React, { useState } from 'react';
import Sidebar from './Sidebar';
import TopBar from './TopBar';

const MainLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <TopBar onMenuClick={() => setSidebarOpen(true)} />
      <main className="transition-all duration-300 ml-0 md:ml-20 lg:ml-[280px] mt-16 p-4 md:p-6 lg:p-8">
        {children}
      </main>
    </div>
  );
};

export default MainLayout;
